import { atom } from 'jotai'

// Types
export interface CreditCardData {
    cardNumber: string
    cardHolder: string
    expiryMonth: string
    expiryYear: string
    cvv: string
}

export interface PaymentResult {
    success: boolean
    transactionId?: string
    errorMessage?: string
}

// Atoms
export const creditCardAtom = atom<CreditCardData>({
    cardNumber: '',
    cardHolder: '',
    expiryMonth: '',
    expiryYear: '',
    cvv: ''
})

export const isProcessingPaymentAtom = atom<boolean>(false)
export const paymentResultAtom = atom<PaymentResult | null>(null)
export const paymentErrorAtom = atom<string | null>(null)

// Derived: Check if card is valid
export const isCardValidAtom = atom(get => {
    const card = get(creditCardAtom)

    const cardNumberValid = card.cardNumber.replace(/\s/g, '').length >= 15
    const cardHolderValid = card.cardHolder.length >= 2
    const expiryValid = card.expiryMonth.length === 2 && card.expiryYear.length === 2
    const cvvValid = card.cvv.length >= 3

    return cardNumberValid && cardHolderValid && expiryValid && cvvValid
})

// Action: Update card field
export const updateCardFieldAtom = atom(null, (get, set, field: keyof CreditCardData, value: string) => {
    const current = get(creditCardAtom)
    set(creditCardAtom, { ...current, [field]: value })
})

// Action: Reset payment state
export const resetPaymentAtom = atom(null, (_get, set) => {
    set(creditCardAtom, {
        cardNumber: '',
        cardHolder: '',
        expiryMonth: '',
        expiryYear: '',
        cvv: ''
    })
    set(isProcessingPaymentAtom, false)
    set(paymentResultAtom, null)
    set(paymentErrorAtom, null)
})
